import React from 'react';
import NtxPeoples from '../../../NTX/Peoples/NtxPeoples2';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';

const EditSuppliers: React.FC = () => {
  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: 'Suppliers',
      link: '/FLEETSettings/Suppliers',
    },
    {
      name: 'EditSuppliers',
      link: null,
    },
  ];
  return (
    <div>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName="EditSuppliers" />

      <NtxPeoples typeCode="SUPPLIERS" isUpdate={true} />
    </div>
  );
};

export default EditSuppliers;
